import { T_OFFLINE_OVERLAY_PAGE_CONSTANTS } from './TYPES'

const DE_OFFLINE_OVERLAY_PAGE_CONSTANTS: T_OFFLINE_OVERLAY_PAGE_CONSTANTS = {
  OFFLINE_TITLE: 'Keine Internetverbindung',
  OFFLINE_DESCRIPTION:
    'Bitte überprüfe deine Internetverbindung, um die App weiterhin zu nutzen.'
}

export default DE_OFFLINE_OVERLAY_PAGE_CONSTANTS
